import React from 'react';
import { useRouting } from 'hooks/useRouting';
import { useCustomHeaderTitle } from 'hooks/useCustomHeaderTitle';

const WhatIsNecessaryYield = (): React.ReactElement => {
  useCustomHeaderTitle('必要な年利回りとは');

  const routing = useRouting();
  const goBack = () => {
    routing.backRouting(true);
  };

  return (
    <>
      <div className="flex flex-col text-bluegray-700 bg-white min-h-full">
        <div className="p-4">
          <div className="flex flex-row">
            <div className="text-lg font-bold">必要な年利回りとは</div>
          </div>
          <div className="mt-4 text-sm">
            毎月の現金積み立てだけでなく運用と合わせて目標金額を目指す場合、その運用に必要な利回りのことです。
          </div>
          <div className="text-sm">
            （必要利回りが高ければ高いほど、一般的にリスクは高くなります。）
          </div>
          <div className="flex flex-row justify-center">
            <img
              src="/static/images/advisor/yield.svg"
              alt="年利回り"
              className="mt-8 items-center"
            />
          </div>
          <button
            className="mt-4 p-2 text-bluegray-500 justify-center w-full text-sm"
            onClick={goBack}>
            戻る
          </button>
        </div>
      </div>
    </>
  );
};

export default WhatIsNecessaryYield;
